import { UrlObject } from 'url'
import * as _ from 'lodash'

import { getLocale } from './helper'

export const indexPage = {
  routeUrl(): UrlObject {
    let pathname = '/'
    return {
      pathname,
    }
  },
  routeUrlAlias(): UrlObject {
    let pathname = '/'
    let locale = getLocale()

    if (!_.isEmpty(locale)) {
      pathname = `/${locale}` + pathname
    }

    return { pathname }
  },
}
